export default __webpack_public_path__ + "static/media/Memorabilia1.6d8690cc.png";